import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";
import { Lock } from "lucide-react";
import Seo from "@/components/Seo";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (user && user !== false) nav("/admin", { replace: true });
  }, [user, nav]);

  const onSubmit = async (e) => {
    e.preventDefault();
    setErr("");
    setBusy(true);
    try {
      await login(email, password);
      nav("/admin");
    } catch (ex) {
      setErr(formatApiErrorDetail(ex.response?.data?.detail) || ex.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div
      className="max-w-md mx-auto px-4 py-16 md:py-24"
      data-testid="admin-login-page"
    >
      <Seo title="Admin" noindex />
      <div className="brut-lg bg-white p-8">
        <div className="flex items-center gap-2 font-mono uppercase text-[11px] tracking-widest mb-3">
          <Lock className="w-3.5 h-3.5" strokeWidth={2.5} />
          Restricted area
        </div>
        <h1 className="font-display text-4xl md:text-5xl tracking-tighter leading-none mb-6">
          Admin login.
        </h1>

        <form onSubmit={onSubmit} className="space-y-4">
          <div>
            <label className="font-mono uppercase text-[11px] tracking-widest block mb-1.5">
              Email
            </label>
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              data-testid="admin-email-input"
              className="w-full brut bg-white px-4 py-3 focus:outline-none"
            />
          </div>
          <div>
            <label className="font-mono uppercase text-[11px] tracking-widest block mb-1.5">
              Password
            </label>
            <input
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              data-testid="admin-password-input"
              className="w-full brut bg-white px-4 py-3 focus:outline-none"
            />
          </div>
          {err && (
            <div
              className="brut pcs-bg-pink text-white px-3 py-2 font-mono text-sm"
              data-testid="admin-login-error"
            >
              {err}
            </div>
          )}
          <button
            type="submit"
            disabled={busy}
            data-testid="admin-login-submit"
            className="w-full brut pcs-bg-pink text-white px-4 py-3 font-bold uppercase tracking-wide brut-press disabled:opacity-60"
          >
            {busy ? "Signing in..." : "Sign in"}
          </button>
        </form>
      </div>
    </div>
  );
}
